// extracted by mini-css-extract-plugin
var _1 = "boldText--PWSNv";
var _2 = "deleteIcon--tBqmP";
var _3 = "deleteTitle--thCw0";
var _4 = "errorContent--l4vna";
var _5 = "errorText--FFUQc";
var _6 = "failedIcon--C88Dj";
var _7 = "itemNumber--QBAXB";
var _8 = "loadingContainer--oCoPl";
var _9 = "loadingText--eWN5T";
var _a = "successIcon--iubPu";
export { _1 as "boldText", _2 as "deleteIcon", _3 as "deleteTitle", _4 as "errorContent", _5 as "errorText", _6 as "failedIcon", _7 as "itemNumber", _8 as "loadingContainer", _9 as "loadingText", _a as "successIcon" }
